import { useEffect, useState } from 'react';
import api from '../../../newApi/apiNet';
import { IRoleWithUsers } from '../../../interfaces/IRoleWithUsers';
import { NotificationStatus } from '../../notification/Notification';
import { Link, useNavigate } from 'react-router-dom';
import { useNotification } from '../../../providers/NotificationProvider';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../../hooks/useAuth';
import { PulseLoader } from '../../loaders/PulseLoader';
import { useAppSelector } from '../../../stores/store.ts';
import { selectCurrentUser } from '../../auth/authSelectors.ts';

export const AccountManagementRolesWithUsersList = () => {
    const [usersWithRoles, setUsersWithRoles] = useState<IRoleWithUsers[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const _navigate = useNavigate();
    const _notificationService = useNotification();
    const { user } = useAuth();
    const _currentUser = useAppSelector(selectCurrentUser);

    useEffect(() => {
        if (user || _currentUser)
            (async () => {
                try {
                    setIsLoading(true);
                    const result = await api.getRolesWithUsers();
                    setUsersWithRoles(result.data);
                    setIsLoading(false);
                } catch (error) {
                    _navigate('/ustawienia/uprawnienia/');
                    _notificationService.showNotification('Żądanie niepowiodło się', 'Żądanie nie powiodło się, spróbuj ponownie.', NotificationStatus.failure);
                }
            })();
    }, [user, _currentUser]);

    return (
        <div className="max-w-xl animate-opacityEaseIn">
            <h1 className="text-3xl">Zarządzanie przypisanymi użytkownikami</h1>
            <div className="h-0.5 w-28 bg-sky-500 my-4 rounded-r-full" />
            {isLoading &&
                <PulseLoader description="Ładowanie ..." />
            }
            {usersWithRoles.map(role =>
                <div key={role.id} className="mt-5">
                    <p className="text-xl">{role.name}</p>
                    {role.users.length === 0 ?
                        <div className="bg-neutral-950 rounded-lg mt-2 text-neutral-200">
                            <p className="p-2">Brak przypisanych użytkowników</p>
                        </div>
                        :
                        <ul className="bg-neutral-950 rounded-lg mt-2 overflow-hidden text-neutral-200">
                            {role.users.map((user, index) =>
                                <li key={user.id}
                                    className={`relative flex justify-between items-center hover:bg-neutral-700 p-2 px-2 border-neutral-600 hover:text-white transition ${index < role.users.length - 1 ? 'border-b' : ''}`}>
                                    <p>{user.email ?? user.customerId}</p>
                                    <ChevronRightIcon className="w-7 h-7" />
                                    <Link className="absolute inset-0"
                                          to={`/ustawienia/uprawnienia/uzytkownik/${user.id}`} />
                                </li>,
                            )}
                        </ul>
                    }
                </div>,
            )}</div>
    );
};
